import React from 'react';

const icon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <defs>
      <circle id="ca7p6cg2da" cx="20" cy="20" r="20" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle
        cx="20"
        cy="20"
        r="20"
        transform="matrix(1, 0, 0, 1, 0, 0)"
        fill="#E8E7E6"
      />
      <path
        fill="#B2B5B2"
        d="M 18.02 29.05 L 22.894 29.05 C 23.384 29.05 23.783 28.652 23.783 28.161 C 23.783 28.113 23.779 28.066 23.771 28.018 L 22.519 20.313 C 24.103 19.553 25.203 17.958 25.203 16.104 C 25.203 13.524 23.079 11.429 20.458 11.429 C 17.84 11.429 15.714 13.524 15.714 16.104 C 15.711 17.96 16.81 19.554 18.397 20.314 L 17.143 28.018 C 17.064 28.503 17.393 28.959 17.878 29.038 C 17.925 29.046 17.973 29.05 18.021 29.05 Z"
      />
    </g>
  </svg>
);

export default icon;
